import React, {useEffect} from 'react';
import { MessageView, useTheme } from 'neon-design-system';
import { useAuth0, useAuth0Data } from 'neon-auth0';
import { useLogger } from './components/providers/logger/Logger';
import { LogLevel, LogAction } from './components/providers/logger/logger-types';
import { redirectToUrl } from './index';
import jwt from 'jwt-decode';
import { config } from './config';
import { redirectToCompleteProfile } from 'neon-utils';

const Auth0ErrorCallback = (error: { message: string; title?: string }): JSX.Element => {

	const { getAccessTokenSilently, logout, error: errorAuthO, isLoading, isAuthenticated } = useAuth0();

	const { theme } = useTheme();
	const { printLog } = useLogger();
	const { accessToken } = useAuth0Data();

	useEffect(() => {
		if (isAuthenticated && !isLoading && !errorAuthO) {

			getAccessTokenSilently().then(token => {
				const neonUserId = jwt<any>(token)[config.auth0.namespace + 'neonUserId'];
				if (!neonUserId) {
					redirectToCompleteProfile(config.landingPageUrl, window.location.href);
				}

			}).catch((e) => {
				console.log('Failed to set access token. Error:', e);
			});
		}
	}, [getAccessTokenSilently, errorAuthO, isLoading, isAuthenticated, accessToken]);


	const title = error.title || 'Authentication Error';
	const logMessage = title + ' - ' + error.message;
	printLog(LogLevel.INFO, LogAction.LoggedIn, logMessage);

	return <div style={{ marginTop: theme.spacing(16) }}>
		<MessageView
			styleName="error"
			title={title}
			primaryAction={{
				label: 'Refresh',
				onClick: () => window.location.reload()
			}}
			secondaryAction={isAuthenticated ? {
				label: 'Logout',
				onClick: (): void => {
					logout({ returnTo: redirectToUrl()?.href });
					printLog(LogLevel.INFO, LogAction.LoggedOut, logMessage);
				}
			} : undefined}
		>
			{error.message}
		</MessageView>
	</div>;
};


export default Auth0ErrorCallback;
